module.exports = __webpack_public_path__ + "static/media/logo-mini.ed774d2c.png";